/** Buckets de fila compatibles con «Promedio del total por periodo». */
export const AVG_PERIOD_SUM_DISPLAY_BUCKETS = ['hourOfDay', 'dayOfWeek', 'week', 'month'];

export const AVG_PERIOD_SUM_AGG = {
  value: 'avgPeriodSum',
  label: 'Promedio del total por periodo',
};

/** Etiqueta corta según agrupación temporal en filas. */
export function avgPeriodSumHint(dateBucket) {
  switch (dateBucket) {
    case 'hourOfDay':
      return 'Suma el total de cada día y promedia por hora (0–23). Ej.: hora 14 → (39+41)/2=40.';
    case 'dayOfWeek':
      return 'Suma el total de cada día calendario y promedia por día de la semana (Lun–Dom).';
    case 'week':
      return 'Suma el total de cada día calendario y promedia por semana.';
    case 'month':
      return 'Suma el total de cada día calendario y promedia por mes.';
    default:
      return 'Suma en el periodo menor (día) y promedia cuando la dimensión se repite.';
  }
}

export function isAvgPeriodSumAggregation(agg) {
  return agg === 'avgPeriodSum' || agg === 'avgDailySum';
}

/** Primera columna fila con bucket temporal compatible. */
export function findAvgPeriodSumRowBucket(columns, context, getColumnMeta) {
  for (const c of columns || []) {
    if (!c?.tableId || !c?.column) continue;
    if (c.role === 'value' || c.jsonMode === 'arrayCount' || c.jsonMode === 'arraySum') continue;
    const meta = getColumnMeta?.(context, c);
    const isDate = meta?.logicalType === 'date' || meta?.logicalType === 'datetime';
    if (!isDate) continue;
    if (AVG_PERIOD_SUM_DISPLAY_BUCKETS.includes(c.dateBucket)) {
      return c.dateBucket;
    }
  }
  return null;
}
